// Copyright (c) 2026 Goffy. All Rights Reserved.

/**
 * Blind finish: the last few holes of a round stay hidden from other groups and off the live
 * leaderboard until the tour organiser reveals them. The server owns which holes those are
 * (see RoundBlindFinishState on round.state); the client only offers the setting and renders
 * what it is told.
 */

/** The most closing holes a round may hide; mirrors tour-service's BlindFinishPolicy.MaxHoles. */
export const BLIND_FINISH_MAX_HOLES = 5;

/** The choices the round settings editor offers: off, then 1..5 holes. */
export const BLIND_FINISH_OPTIONS: readonly number[] = [0, 1, 2, 3, 4, 5];

export function isValidBlindFinishHoles(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= BLIND_FINISH_MAX_HOLES;
}
